import React from 'react';

import Button from '../../../components/themed/Button';

import OfferPanelLayout from './OfferPanelLayout';

type OfferStoreRequiredProps = {
  onChooseStore: () => void;
};

const OfferStoreRequired = ({onChooseStore}: OfferStoreRequiredProps) => (
  <OfferPanelLayout
    testID="exclusive-offer-store-required"
    heading="Choose your store to see this offer">
    <Button title="Choose store" onPress={onChooseStore} />
  </OfferPanelLayout>
);

export default OfferStoreRequired;
